module.exports = __webpack_public_path__ + "img/budget.bd9400f.svg";